//CallProviderLinkV1.tsx
import { Link as ExternalLink } from "@trussworks/react-uswds";
import { useTranslation } from "react-i18next";
import { ReactComponent as Telephone } from "../../images/phone.svg";
import { V1Clinic } from "../../types/v1_schemas";

function CallProviderLink({
  v1Clinic,
}: {
  v1Clinic: V1Clinic | undefined;
}) {
  const { t } = useTranslation();

  // const isV1Clinic = (arg: any) => {
  //   if ('accountId' in arg && 'clinicPhones' in arg ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  let clinicPhone = null;

  let clinicPhoneNumber = null;
  if (v1Clinic) {
    if (v1Clinic.clinicPhones?.length) {
      let clinicPhones = v1Clinic?.clinicPhones
      clinicPhone = clinicPhones.filter(thisPhone => thisPhone.phoneNumberTypeText === 'Front desk' || thisPhone.phoneNumberTypeText === "Recepción");
      if (clinicPhone?.length) {
        clinicPhoneNumber = clinicPhone[0].phone;
      }
    }
  }


    if (!clinicPhone || !clinicPhoneNumber) 
   {
    return null;
  } else {
    return (
      <ExternalLink
        className="display-flex flex-align-center flex-justify-center padding-1"
        target="_blank "
        href={`tel:${clinicPhoneNumber}`}
      >
        <Telephone className="margin-right-1 margin-bottom-05" />
        {t("callProvider")}
      </ExternalLink>
    );
  }
}
export default CallProviderLink;
